import type { ReactNode } from 'react';
import React, { createContext } from 'react';
type PDFContextPropsT = {
  renderPDFFrame: (currentPage: number, canvasContext: CanvasRenderingContext2D) => void;
  getPage: (currentPage: number) => Promise<{
    view: [number, number, number, number];
  }>;
};
type PropsT = {
  children: ReactNode;
  renderPDFFrame: (currentPage: number, canvasContext: CanvasRenderingContext2D) => void;
  getPage: (currentPage: number) => Promise<{
    view: [number, number, number, number];
  }>;
};
export const PDFContext = createContext<PDFContextPropsT>({
  renderPDFFrame: () => {},
  getPage: () => Promise.resolve({
    view: [0, 0, 0, 0]
  })
});
export const PDFProvider = ({
  children,
  renderPDFFrame,
  getPage
}: PropsT) => {
  return <PDFContext.Provider value={{
    renderPDFFrame,
    getPage
  }}>
      {children}
    </PDFContext.Provider>;
};